import React from 'react';
export function BrandPartners() {
  const partners = [{
    name: 'Clipsal',
    fallback: 'Clipsal'
  }, {
    name: 'Daikin',
    fallback: 'Daikin'
  }, {
    name: 'Hager',
    fallback: 'Hager'
  }, {
    name: 'Philips',
    fallback: 'Philips'
  }];
  return <section className="py-10 bg-white border-b border-gray-100" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4" data-id="element-2">
        <p className="text-center text-sm font-bold text-gray-400 uppercase tracking-wider mb-6" data-id="element-3">
          Trusted Brands We Install & Recommend
        </p>
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-60" data-id="element-4">
          {partners.map((partner, index) => <div key={index} className="grayscale hover:grayscale-0 transition-all duration-300 hover:opacity-100 cursor-pointer text-xl md:text-2xl font-heading font-extrabold text-navy/60 hover:text-navy" data-id="element-5">
              {partner.fallback}
            </div>)}
        </div>
      </div>
    </section>;
}